<template>
    <div class="inner-page">
     
                <view-item v-if="!!item" :item="item" @success="resetItems" @cancel="item = false"
                    @delete-item="deleteType"></view-item>

                <list-items v-else @show-item="showItem" ref="table">
                    <!-- <b-button block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                            :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button> -->
                            <b-button block variant="primary"  @click="item = {}"><img v-b-tooltip.hover
                                :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
                </list-items>
      
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'AssetRental',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data() {
        return {
            tabIdx: 0,
            item: null,
        }
    },
    computed: {
        componentName(){
            return this.$translate('asset_rental')
        },
        items() {
            const items =this.$store.state.asset_rental.items
            return items
        },
    },
    methods: {
        async doSearch() {

            console.log('do search is called');
            await this.$store.dispatch('asset_rental/fetchAll')
        },
        showItem(id) {
            console.log('idssss', id)
            this.item = this.items.find(x => x.id === id)
            this.$store.state.asset_rental.item = this.item; 
        
        },
        resetItems(status) {
            this.genericToast(
                this.componentName,
                status,
                'success',
                `${this.componentName} ${status.toLowerCase()} ${this.$translate('succcessfully')}`
            )
            this.item = null
            // this.doSearch()
        },
    },
}
</script>
<style></style>
